import React from 'react'
import Not_Found from '../../components/NotFound/Not_Found';
export default function NotFound() {
  return (
    <>
      <Not_Found />
    </>
  )
}
